import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=14e5172d&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=14e5172d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e5172d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14e5172d')) {
      api.createRecord('14e5172d', component.options)
    } else {
      api.reload('14e5172d', component.options)
    }
    module.hot.accept("./FAQ.vue?vue&type=template&id=14e5172d&scoped=true&", function () {
      api.rerender('14e5172d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Other/FAQ.vue"
export default component.exports